import type { Language, Region } from '@lemonade-hq/lemonation';

const pathToLangRegionMap: { [key: string]: [Language, Region] } = {
  '/de/en': ['en', 'DE'],
  '/fr/en': ['en', 'FR'],
  '/nl/en': ['en', 'NL'],
  '/de': ['de', 'DE'],
  '/fr': ['fr', 'FR'],
  '/nl': ['nl', 'NL'],
  '/uk': ['en', 'GB'],
};

export const getLangAndRegion = (pathname: string): [Language, Region] => {
  for (const path in pathToLangRegionMap) {
    if (pathname.startsWith(path)) {
      return pathToLangRegionMap[path];
    }
  }

  return ['en', 'US'] as [Language, Region];
};
